import React from 'react';

export default function HomeWhatChangedSection({
  items = [],
  loading = false,
  error = null,
  onOpenItem,
  show = true,
  isFirstSession = false,
}) {
  if (!show) return null;

  return (
    <section
      className="rounded-3xl border border-slate-800/70 bg-gradient-to-b from-slate-900/65 to-slate-950/55 p-4 sm:p-5"
    >
      <div className="mb-4 flex items-end justify-between gap-3">
        <div>
          <div className="text-[11px] font-semibold uppercase tracking-[0.18em] text-purple-300/70">
            {isFirstSession ? 'What Happens Next' : 'What Changed'}
          </div>
          <div className="mt-1 text-lg font-extrabold text-slate-50">
            {isFirstSession ? 'Your verdicts will land here.' : 'Verdicts landed while you were gone.'}
          </div>
          <div className="mt-1 text-sm text-slate-400">
            {isFirstSession
              ? 'After you vote, this becomes the place to collect results.'
              : 'Open the verdicts that actually resolved while you were out.'}
          </div>
        </div>
      </div>

      {loading ? (
        <div className="text-sm text-slate-400">Checking which verdicts landed...</div>
      ) : error ? (
        <div className="text-sm text-slate-400">Couldn&apos;t load resolved verdict updates right now.</div>
      ) : items.length === 0 ? (
        <div className="rounded-xl border border-slate-800/70 bg-slate-950/35 px-4 py-4 text-sm text-slate-400">
          {isFirstSession
            ? 'Your first verdicts will show up here after you vote.'
            : 'Nothing resolved yet. Vote now, then come back for the verdict.'}
        </div>
      ) : (
        <div className="space-y-2.5">
          {items.map((item) => (
            <button
              key={item.id}
              onClick={() => onOpenItem?.(item)}
              className="group w-full rounded-2xl border border-slate-800/70 bg-slate-950/45 px-4 py-3 text-left transition hover:border-purple-500/25 hover:bg-slate-950/70"
            >
              <div className="flex items-center justify-between gap-3">
                <div className="flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.18em] text-purple-300/80">
                  <span>{item.displayEyebrow || 'Verdict Landed'}</span>
                  {item.is_unread && (
                    <span className="inline-flex h-2 w-2 rounded-full bg-purple-400" aria-hidden="true" />
                  )}
                </div>
                <div className="text-[11px] font-semibold uppercase tracking-[0.14em] text-slate-500 transition group-hover:text-slate-300">
                  Open Now
                </div>
              </div>
              <div className="mt-2 line-clamp-2 text-base font-bold leading-snug text-slate-50">
                {item.displayTitle || item.title || item.trial_title}
              </div>
              <div className="mt-1 line-clamp-2 text-sm text-slate-300">
                {item.displayBody || item.body || 'Open the result and see how it landed.'}
              </div>
            </button>
          ))}
        </div>
      )}
    </section>
  );
}
